'use client'

import { SplashController } from '@sushiswap/ui'
import { WalletProvider } from 'src/lib/wallet'
import { SidebarProvider } from '../_ui/sidebar'
import { BalanceProvider } from './_common/ui/balance-provider/balance-provider'
import { PriceProvider } from './_common/ui/price-provider/price-provider/price-provider'

export function Providers({ children }: { children: React.ReactNode }) {
  return (
    <WalletProvider>
      <PriceProvider>
        <SidebarProvider>
          <BalanceProvider>
            <SplashController>{children}</SplashController>
          </BalanceProvider>
        </SidebarProvider>
      </PriceProvider>
    </WalletProvider>
  )
}
